import React from 'react';
import { M } from '../utils/maskot';

// <Maskot type="mod" name="thinking" size={48} alt="Düşünüyor" />
// type: mod | rol | paket | kar
// name: ilgili isim (örn. 'thinking', 'veli', 'kurumsal', 'doktor')
// size: piksel (varsayılan 48)
// glow: arkaplan halo efekti (true/false)
export function Maskot({
  type = 'kar',
  name,
  size = 48,
  alt = '',
  glow = false,
  style = {},
  className = '',
  ...rest
}) {
  if (!name) return null;
  const fn = M[type];
  if (!fn) return null;
  const src = fn(name);

  const baseStyle = {
    width: size,
    height: size,
    objectFit: 'contain',
    display: 'block',
    flexShrink: 0,
    ...(glow ? { filter: 'drop-shadow(0 4px 14px rgba(168,218,255,0.5))' } : {}),
    ...style,
  };

  return (
    <img
      src={src}
      alt={alt || `${type}-${name}`}
      width={size}
      height={size}
      loading="lazy"
      className={className}
      style={baseStyle}
      {...rest}
    />
  );
}
